

var space = require('./space');
var width = require('./width');
var height = require('./height');
var minHeight = require('./min-height');
var fontFamily = require('./font-family');
var fontSize = require('./font-size');
var color = require('./color');
var fill = require('./fill');
var responsiveStyle = require('./responsive-style');
var removeProps = require('./remove-props');
var util = require('./util');
var textShadow = require('./text-shadow');
var boxShadow = require('./box-shadow');
var borderRadius = require('./border-radius');
var borderColor = require('./border-color');
var borderImage = require('./border-image');
var constants = require('./constants');

module.exports = {
  constants: constants,
  responsiveStyle: responsiveStyle,
  removeProps: removeProps,
  util: util,
  boxShadow: boxShadow,
  borderColor: borderColor,
  borderImage:borderImage,
  borderRadius:borderRadius,
  color: color,
  fill: fill,
  fontSize: fontSize,
  fontFamily: fontFamily,
  height: height,
  minHeight: minHeight,
  textShadow: textShadow,
  space: space,
  width: width,
};


// WEBPACK FOOTER //
// ./src/interface/atomic/quarks/index.js